import SeoLandingTemplate, { SeoLandingPageData } from "@/components/marketing/SeoLandingTemplate";

const page: SeoLandingPageData = {
  path: "/common-interview-questions",
  title: "Common Interview Questions",
  seoTitle: "Common Interview Questions to Prepare For | HiredCoach",
  seoDescription:
    "Use this hub page to prepare for the most common interview questions and jump into deeper answer guides and mock interview practice.",
  heroEyebrow: "Common interview questions",
  heroHeadline: "It may be boring to get the general questions, but you still need to ace them",
  heroSubhead:
    "",
  heroPrimaryCta: "Say these out loud",
  heroPanelEyebrow: "Start here",
  heroPanelTitle: "Get the big ones to actually hold up",
  heroPanelBullets: [
    "Tell me about yourself",
    "What's your biggest weakness",
    "Why do you want to work here",
    "Tell me about a time you disagreed with a manager",
  ],
  heroPanelFooter: "Most people fail to deliver a convincing answer",
  frameworkTitle: "The quickest fixes",
  frameworkBullets: [
    "Learn to tell your story clearly and confidently",
    "Fix your \"Why should we hire you\" pitch to seem indispensible",
    "Build one weakness answer that sounds believable and shows humility",
    "Pick a conflict that has a learning outcome worth expanding on",
  ],
  exampleTitle: "All it takes is practice",
  exampleBlocks: [
    "Use our mock interviews",
    "Learn to relate your experience directly to the role",
    "Practice behavioral quesitons",
  ],
  mistakesTitle: "Why people still feel unprepared",
  mistakes: [
    "They research forever and barely practice",
    "They never receive critiques or feedback on their answers",
    "They assume confidence shows up on interview day",
  ],
  mistakesFooter: "That's why they freeze when it matters",
  ctaEyebrow: "Practice builds confidence",
  ctaTitle: "Be your best advocate",
  ctaBullets: [
    "Start with the most common questions",
    "Fix your biggest weaknesses first",
    "Practice until your answers actually sound natural",
    "Get key feedback to hone your performance",
  ],
  ctaInfoCard: {
    title: "Coach U interview library",
    path: "/public-learn",
    description: "Start with the Coach U library, then move into targeted answer drills.",
  },
  ctaActionTitle: "Personalized mock interviews",
  ctaActionDescription: "Use our mock interviews to practice and be an incredible candidate",
  relatedTitle: "Don't stop at just these",
  relatedLinks: [
    {
      title: "Tell Me About Yourself Interview Answer",
      path: "/tell-me-about-yourself",
      description: "Learn how to answer 'Tell me about yourself' with a clear structure, a sample answer, and a fast path into Coach U practice.",
    },
    {
      title: "Greatest Weakness Interview Answer",
      path: "/greatest-weakness",
      description: "Build a credible answer to 'What is your greatest weakness?' with examples, mistakes to avoid, and a Coach U CTA.",
    },
    {
      title: "Why Should We Hire You Answer",
      path: "/why-should-we-hire-you",
      description: "Answer 'Why should we hire you?' with a focused value pitch, a sample answer, and a direct path into practice and feedback.",
    },
    {
      title: "Behavioral Interview Questions and Answers",
      path: "/behavioral-interview-questions",
      description: "Review common behavioral interview questions, how to answer them well, and how to practice them with AI feedback.",
    },
  ],
  faqs: [
    { question: "What are the most common interview questions?", answer: "The core ones\n\nTell me about yourself\nWeakness\nWhy should we hire you\n\na few behavioral stories" },
    { question: "How do you prioritize interview prep?", answer: "Start with the repeat offenders\n\nThen layer in role-specific and behavioral answers" },
  ],
  pricingTitle: (
    <>
      Don&apos;t just know the answers
      <br />
      Be able to say them
    </>
  ),
  pricingDescription: "Practice until your answers actually sound natural",
};

export default function CommonInterviewQuestionsPage() {
  return <SeoLandingTemplate page={page} />;
}
